










































import Vue from 'vue';
import Component from 'vue-class-component';
import ItemList from '@/components/tickets/tickets-form/common/ItemList.vue';
import { tickets, user } from '@/modules/shared/shared/store/namespaces';
import { IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: { ItemList },
})
export default class PDTChangeCommentSection extends Vue {
    writeChange: boolean = false;
    comment: string[] = [''];
    sections: { id: number | null; name: string | null }[] = [{ id: null, name: null }];
    maxCommentsNumber: number = 10;
    rules: any = rules;

    sendRequestForChange() {
        this.$emit('sendRequestForChange', this.comment[0], this.sections[0].id);
    }

    @tickets.State('commentarySections') commentarySections;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @tickets.State('workflowSteps') workflowSteps;
}
